import React from 'react';

function SectionHeader({ label, title, description, compact = false }) {
  return (
    <div className={compact ? 'section-heading section-heading--compact' : 'section-heading'}>
      <span className="section-label">{label}</span>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

export default SectionHeader;
